import { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { AutomationEditorView } from '../types/AutomationEditorView';
import { useCurrentAutomationId } from './useCurrentAutomationId';
import { useGetAutomationsBasePath } from './useGetAutomationsBasePath';

export const useAutomationEditorView = (): {
  currentEditorView: AutomationEditorView | undefined;
  setCurrentEditorView: (view: AutomationEditorView) => void;
} => {
  const history = useHistory();
  const currentAutomationId = useCurrentAutomationId();
  const { automationEditorView: currentEditorView } =
    useParams<{ workflowEventSettingId?: string; automationEditorView?: AutomationEditorView }>();
  const { automationsBasePath } = useGetAutomationsBasePath();

  const setCurrentEditorView = useCallback(
    (view: AutomationEditorView): void => {
      history.push(`${automationsBasePath}/${currentAutomationId}/${view}`);
    },
    [history, automationsBasePath, currentAutomationId],
  );

  useEffect(() => {
    if (!currentEditorView && currentAutomationId) {
      setCurrentEditorView(AutomationEditorView.Settings);
    }
  }, [currentEditorView, currentAutomationId, setCurrentEditorView]);

  return { currentEditorView, setCurrentEditorView };
};
